import React from 'react';
import { FadeIn } from './FadeIn';
import { Star } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    quote: 'Yo estaba completamente perdida… este material me dio claridad desde el primer día. Ahora ya tengo mi primera idea lista.',
    name: 'Mariana R.'
  }, {
    quote: 'Lo mejor es que no te confunde. Te dice exactamente qué hacer. Eso para mí fue lo que marcó la diferencia.',
    name: 'Laura G.'
  }, {
    quote: 'Había visto mil videos y nada me quedaba claro. Aquí todo está organizado. Por fin entendí cómo empezar.',
    name: 'Daniela P.'
  }, {
    quote: 'Me quitó el miedo. Pensé que era más complicado, pero explicado así se siente posible.',
    name: 'Andrea M.'
  }, {
    quote: 'Solo con la lista de productos ya entendí por dónde empezar. Eso vale muchísimo.',
    name: 'Karla S.'
  }, {
    quote: 'La plantilla para elegir productos es lo mejor. Antes elegía por intuición, ahora lo hago con lógica.',
    name: 'Valentina C.'
  }, {
    quote: 'Me encanta porque no es humo. Es directo, claro y práctico.',
    name: 'Sofía L.'
  }, {
    quote: 'Literalmente pasé de no saber nada… a tener un plan en una semana.',
    name: 'Camila T.'
  }, {
    quote: 'Sentí que por primera vez alguien explicó esto para personas normales.',
    name: 'Paola D.'
  }, {
    quote: 'Me ayudó a dejar de pensar tanto y empezar a actuar.',
    name: 'Gabriela V.'
  }, {
    quote: 'El checklist me dio orden. Antes no sabía ni qué paso seguía.',
    name: 'Natalia F.'
  }, {
    quote: 'Por este precio es una locura todo lo que incluye. Vale muchísimo más.',
    name: 'Jessica H.'
  }];
  return <section className="bg-brand-white py-24 px-6" data-id="element-246">
      <div className="max-w-7xl mx-auto" data-id="element-247">
        <FadeIn data-id="element-248">
          <div className="text-center mb-16" data-id="element-249">
            <span className="text-4xl mb-4 block" data-id="element-250">💬</span>
            <h2 className="text-3xl md:text-4xl font-bold text-brand-green uppercase tracking-wide" data-id="element-251">
              Lo que otras personas están logrando
            </h2>
          </div>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-252">
          {testimonials.map((testimonial, index) => <FadeIn key={index} delay={0.05 * (index % 6)} data-id="element-253">
              <div className="bg-brand-beige/40 p-8 rounded-2xl h-full flex flex-col border border-brand-beige hover:border-brand-gold/30 transition-colors" data-id="element-254">
                <div className="flex gap-1 mb-4" data-id="element-255">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-brand-gold text-brand-gold" data-id="element-256" />)}
                </div>
                <p className="text-brand-text/90 italic mb-6 flex-grow leading-relaxed" data-id="element-257">
                  "{testimonial.quote}"
                </p>
                <p className="font-semibold text-brand-green" data-id="element-258">
                  – {testimonial.name}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}